const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 816 209",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(13.8889,0,0,13.8889,-1434.04,-1997.26)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.61461,0,0,1.29389,-63.4594,-42.2625)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.896,
    cy: 149.599,
    rx: 4.645,
    ry: 5.796,
    style: {
      fill: "rgb(255,193,7)",
      fillOpacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.61461,0,0,1.29389,-41.7087,-42.2625)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.896,
    cy: 149.599,
    rx: 4.645,
    ry: 5.796,
    style: {
      fill: "rgb(255,193,7)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.61461,0,0,1.29389,-19.7634,-42.2625)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.896,
    cy: 149.599,
    rx: 4.645,
    ry: 5.796,
    style: {
      fill: "rgb(255,193,7)",
      fillOpacity: 0.5
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusWarning);
export default __webpack_public_path__ + "static/media/status-warning.d5b7a93aba14d21f372167d605f3a124.svg";
export { ForwardRef as ReactComponent };